// extracted by mini-css-extract-plugin
export default {"container":"ListCard_container__Ecx5p","image":"ListCard_image__veqvr","heading":"ListCard_heading__jueoW","text":"ListCard_text__tvZ3s"};